﻿import * as React from 'react';

import FormikField from './FormikField';
import DropzoneFileUpload from '../../DropzoneFileUpload/Component';

const FormikDropzoneFileUpload = (props) => {
  const { field, form, ...other } = props;

  const handleFilesSelected = (files) => {
    if (files && files.length > 0) {
      const filesArray = form.values[field.name] || [];
      for (let i = 0; i < files.length; ++i) {
        filesArray.push(files[i]);
      }

      form.setFieldValue(field.name, filesArray);
      form.setTouched({ [field.name]: true });
    }
  };

  const handleError = (error) => {
    form.setFieldError(field.name, error);
  };

  const handleFileStatusChange = (file) => {
    const filesArray = form.values[field.name] || [];
    const fileIndex = filesArray.findIndex((x) => x.name === file.name);
    filesArray.splice(fileIndex, 1);
    filesArray.push(file);
    form.setFieldValue(field.name, filesArray);
    form.setTouched({ [field.name]: true });
  };

  return (
    <FormikField field={field} form={form} showNoError>
      <DropzoneFileUpload
        onFilesSelected={handleFilesSelected}
        onFileStatusChange={handleFileStatusChange}
        onError={handleError}
        {...other}
      />
    </FormikField>
  );
};

export default FormikDropzoneFileUpload;
